import React from "react";

function NotFound() {
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          padding: "150px",
        }}
      >
        <article className="article-notfound">
          <div className="blob"></div>
          <h1>
            {" "}
            <span style={{ fontWeight: "700", color: "#2271b1" }}>404</span> -
            Page Not Found!
          </h1>
          <div style={{ margin: "10px 0px" }}>
            <p>
              Sorry for the inconvenience but we&rsquo;re performing some
              maintenance at the moment. If you need to you can always{" "}
              <a href="mailto:team@MetBrains.in">contact us</a>, otherwise
              we&rsquo;ll be back online shortly!
            </p>
            <p>&mdash; The MetBrains Team</p>
          </div>
          <h1
            style={{
              position: "absolute",
              bottom: "0px",
              left: "0px",
              fontFamily: "OvercameFont",
              fontWeight: "300",
              fontSize: "350px",
              color: "#cfd7de25",
              transform: "translate(-20%, 40%)",
            }}
          >
            MetBrains
          </h1>
        </article>
        <figure
          style={{
            position: "absolute",
            bottom: "-10px",
            right: "0px",
            display: "flex",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <img src="/MetBrains_bg_1.png" width="350px" />
        </figure>
      </div>
    </>
  );
}

export default NotFound;
